import React from "react";
import { faBriefcase } from "@fortawesome/free-solid-svg-icons";

import Card from "../common/card";

import "./styles/works.css";

const Works = () => {
	return (
		<div className="works">
			<Card
				icon={faBriefcase}
				title="Work"
				body={
					<div className="works-body">
						<div className="work">
							<img
								src="./safeguard_logo.jpeg"
								alt="Allegro Interactive"
								className="work-image"
							/>
							<div className="work-title">SAFEGUARD GLOBAL</div>
							<div className="work-subtitle">
								Senior Software Engineer
							</div>
							<div className="work-duration">2025 - Present</div>
						</div>

						<div className="work">
							<img
								src="./allegro.png"
								alt="Allegro Interactive"
								className="work-image"
							/>
							<div className="work-title">Allegro Interactive</div>
							<div className="work-subtitle">
								Head of Technology
							</div>
							<div className="work-duration">2024 - 2025</div>
						</div>

						<div className="work">
							<img
								src="./work1.png"
								alt="Rivka Development"
								className="work-image"
							/>
							<div className="work-title">Rivka Development</div>
							<div className="work-subtitle">
								Head of Technology
							</div>
							<div className="work-duration">2019 - 2024</div>
						</div>

						<div className="work">
							<img
								src="./allegro.png"
								alt="Allegro Response Teleservices"
								className="work-image"
							/>
							<div className="work-title">Allegro Response Teleservices</div>
							<div className="work-subtitle">
								Software Developer | IT Support
							</div>
							<div className="work-duration">2015 - 2019</div>
						</div>
						<div className="work">
							<img
								src="./officemax.jpg"
								alt="Officemax"
								className="work-image"
							/>
							<div className="work-title">Officemax</div>
							<div className="work-subtitle">
								IT Specialist
							</div>
							<div className="work-duration">2012 - 2014</div>
						</div>

					</div>
				}
			/>
		</div>
	);
};

export default Works;
